export default __webpack_public_path__ + "static/media/SHERPA.4fa895bf.png";